/** @jsxRuntime classic */
/** @jsx jsx */

import { jsx } from "@emotion/react";
import { animated } from "@react-spring/web";
import React, { memo, useContext } from "react";
import { Context } from "../../../Context";
import YoutubeEmbed from "../../../YoutubeEmbed";
import { playerNewsStyle } from "./style";

const CoachNews = ({ style, player, animating }) => {
  const {
    dictionary: { dictionary },
  } = useContext(Context);
  return (
    <animated.div style={style} css={playerNewsStyle}>
      <h2>{dictionary.menu_news}</h2>
      <div className="news">
        {player.news.map((data) => {
          return (
            <a
              key={data.news_id}
              href={data.url}
              className="news-card"
              target="_blank"
            >
              <h3>{data.title}</h3>
              <p>{data.text}</p>
            </a>
          );
        })}
      </div>
    </animated.div>
  );
};

export default memo(CoachNews);
